import { ValidatorService } from './validator/validator.service';

export const services: any[] = [ValidatorService];

export * from './validator/validator.service';
export * from './prospect/prospect.service';
export * from './client-data/client-data.service';
export * from './account-registration/account-registration.service';
export * from './clear/clear.service';
export * from './client-accounts';
export * from './content/content.service';
export * from './convert-registration/convert-registration.service';
export * from './cost-basis/cost-basis.service';
export * from './email';
export * from './gatekeeper/gatekeeper.service';
export * from './joint-gifting-approval/joint-gifting-approval.service';
export * from './open-account';
export * from './prospect/prospect.service';
export * from './fraud-micro-frontend/fmf.service';
export * from './submit/submit.service';
export * from './submit-metrics/submit-metrics.service';
export * from './validator/validator.service';
export * from './verified-deceased/verified-deceased.service';
export * from './verify-decedent/verify-decedent.service';
export * from './window-ref';
export * from './codeone-zipcode/codeone-zipcode.service';
export * from '@interfaces/cost-basis/cost-basis.service.interface';
export * from './digital-advice/digital-advice.service';
export * from './documents/documents.service';
export * from './draft/draft.service';
export * from './decedent-form-builder/decedent-form-builder.service';
export * from './decedent-validation/decedent-validation.service';
